export default __webpack_public_path__ + "./images/kz.ddb89db6.png";